import { CLOUD_MANAGEMENT, EDIT_DATA_CLASSIFICATION_ENCRYPTION, KEY_MANAGEMENT, MANAGE_DATA_ACCESS_ROLES, MANAGE_DATA_ACCESS_TOKENS, MANAGE_DATA_CLASSIFICATIONS,
  MANAGE_DATA_OWNER_GROUPS, MANAGE_FILE_CLASSIFICATION_AND_PROTECTION_RULES, MANAGE_OBFUSCATION_RULES, MANAGE_ONDATA_CLIENTS, MANAGE_SECUREAI_SETTINGS, MANAGE_SECUREFILE_SETTINGS, ORGANIZATION_USERS, Permissions_new } from "@/constants"


export type SettingsMenuItem =
| 'Organization'
| 'Data Access Policy'
| 'Encryption'
| 'Deployment'
| 'Notification'
| 'SecureFileSettings'
| 'SecureAISettings'

export const allowedSettingsMenus = (ps: Set<Permissions_new>, hasFeature: {
  OnDataDriver: boolean;
  OnDataSecureFile: boolean;
  OnDataSecureDB: boolean;
  OnDataSecureAI: boolean;
}) => {
  const menuItems = new Set<SettingsMenuItem>(hasFeature.OnDataSecureDB ? [
    'Organization', // user can always register/view clients
    'Encryption',   // user can always view DataAccessTokens/ObfsRules
    'Data Access Policy', // user can always view DataClassification, etc.
  ] : [
    'Organization', 
    'Data Access Policy'
  ])
  const x = {
    [ORGANIZATION_USERS]: ['Notification'],
    [CLOUD_MANAGEMENT]: hasFeature.OnDataSecureDB ? ['Deployment'] : [],
    [MANAGE_SECUREFILE_SETTINGS]: hasFeature.OnDataSecureFile ? ['SecureFileSettings'] : [],
    [MANAGE_FILE_CLASSIFICATION_AND_PROTECTION_RULES]: hasFeature.OnDataSecureFile ? ['SecureFileSettings'] : [],
    [MANAGE_SECUREAI_SETTINGS]: hasFeature.OnDataSecureAI ? ['SecureAISettings'] : [],
  } as {[p in Permissions_new]: SettingsMenuItem[]}
  
  return Object.keys(x).reduce((acc, p) => {
    if (ps.has(p as any)) {
      (x as any)[p].forEach((item : SettingsMenuItem) => acc.add(item))
    }
    return acc
  }, menuItems)
}


export const getSettingsMenuDefaultRoute = (item1:SettingsMenuItem|{name:SettingsMenuItem,hasDriverFeature:boolean}, ps:Set<Permissions_new>) => {
  const item = typeof(item1) === 'string' ? item1 : item1.name
  switch (item) {
    case 'Organization':
      return (
        ps.has(ORGANIZATION_USERS) 
        ? '/settings/organization/profile/edit'
        : '/settings/organization/clients')
    case 'Data Access Policy':
      return ('/settings/governance/data-classification')
    case 'Encryption':
      const hasDriverFeature = typeof(item1) !== 'string' && item1.hasDriverFeature
      return (
        ps.has(KEY_MANAGEMENT) ? '/settings/encryption/keys'
      : hasDriverFeature         ? '/settings/encryption/tokens'
      : '/settings/encryption/obfuscation-rule')
    case 'Deployment':
      return (ps.has(CLOUD_MANAGEMENT) ? '/settings/deployment' : null)
    case 'Notification':
      return (ps.has(ORGANIZATION_USERS) ? '/settings/notification' : null)
    case 'SecureFileSettings':
      return (
        ps.has(MANAGE_SECUREFILE_SETTINGS) ? '/settings/securefile/basic' 
      : ps.has(MANAGE_FILE_CLASSIFICATION_AND_PROTECTION_RULES) ? '/settings/securefile/classification-n-protection' 
      : null)
    case 'SecureAISettings':
        return (ps.has(MANAGE_SECUREAI_SETTINGS) ? '/settings/secureai/images' :null)
    default: return null;
  }
}


export const allowOrgSettingRoute = (path:string, ps: Set<Permissions_new>, hasFeature: {
  OnDataDriver: boolean;
  OnDataSecureFile: boolean;
  OnDataSecureDB: boolean;
}):boolean => {
  const path_l = path.toLowerCase()
  const p : Permissions_new|null|boolean =
    ['/settings/organization/profile',
     '/settings/organization/user-manage',
     '/settings/organization/sso-config',].some(x => path_l.startsWith(x)) ? ORGANIZATION_USERS
    
     // allow all user to see registered clients, because they can register encrypt tool/database driver
     // but for manage client actions, they require 'MANAGE_ONDATA_CLIENTS' permit, which should be checked on clients tab ui component
  : ['/settings/organization/clients'].some(x => path_l.startsWith(x))     ? true 
  
  : ['/settings/organization/cloud-subscription',
     '/settings/organization/ip-whitelist',].some(x => path_l.startsWith(x)) ? CLOUD_MANAGEMENT
  : null
  return p === true || (!!p && ps.has(p))
}

export const OrgSettingPermits:Permissions_new[][] = [[ORGANIZATION_USERS], [MANAGE_ONDATA_CLIENTS], [CLOUD_MANAGEMENT]]


export const allowDataAccessSettingRoute = (path:string, hasDBFeature:boolean, ps:Set<Permissions_new>) => {
  const path_l = path.toLowerCase()
  return hasDBFeature ? path_l.startsWith('/settings/governance') : !path_l.startsWith('/settings/governance/data-owner-group') 
}

export const DataAccessSettingPermits:Permissions_new[][] = [[MANAGE_DATA_CLASSIFICATIONS], [MANAGE_DATA_ACCESS_ROLES], [MANAGE_DATA_OWNER_GROUPS]]


export const allowEncryptSettingRoute = (path:string, hasDriverFeature:boolean, hasDBFeature:boolean, ps:Set<Permissions_new>):boolean => {
  const path_l = path.toLowerCase()
  const p : Permissions_new|null|boolean =
    ['/settings/encryption/keys',].some(x => path_l.startsWith(x))             ? KEY_MANAGEMENT
  : ['/settings/encryption/tokens',].some(x => path_l.startsWith(x))           ? hasDriverFeature
  : ['/settings/encryption/obfuscation-rule',].some(x => path_l.startsWith(x)) ? true
  : ['/settings/encryption/info-types',].some(x => path_l.startsWith(x))       ? true
  : null
  return hasDBFeature ? (p === true || (!!p && ps.has(p))) : false
}

export const allowReleaseRoute = (path:string, hasDriverFeature:boolean, hasSecureFileFeature:boolean, hasSecureDBFeature: boolean, ps:Set<Permissions_new>):boolean => {
  const path_l = path.toLowerCase()
  const p : Permissions_new|null|boolean =
    ['/release/jdbc', '/release/odbc', '/release/sqlclient'].some(x => path_l.startsWith(x)) ? hasDriverFeature
  : ['/release/securefile'].some(x => path_l.startsWith(x))                                  ? hasSecureFileFeature
  : ['/release/encryptiontool'].some(x => path_l.startsWith(x))                              ? hasSecureDBFeature
  : null
  return p === true || (!!p && ps.has(p))
}

export const EncryptSettingPermits:Permissions_new[][] = [[KEY_MANAGEMENT], [MANAGE_DATA_ACCESS_TOKENS], [MANAGE_OBFUSCATION_RULES]]

